<!-- gameplay-player.component.html -->
<gameplay-toolbar
  [toolbar]="toolbar"
  [setting]="setting"
  [didAnswer]="didAnswer"
  [progress]="progress"
  [phase]="phase"
  [hasAudio]="hasAudio"
  [isAutoplay]="isAutoplay"
  (selected)="onSelect($event)"
  (action)="onAction($event)"
></gameplay-toolbar>

<div class="gameplay-wrapper">
  @if (card) {
    @if (useTSX) {
      <gameplay-player-tsx
        [setting]="setting"
        [card]="card"
        [didAnswer]="didAnswer"
        [progress]="progress"
        [isAutoplay]="isAutoplay"
        (selected)="onSelect($event)"
        (action)="onAction($event)"
        [rightAnswerDisplayTime]="rightAnswerDisplayTime"
        [wrongAnswerDisplayTime]="wrongAnswerDisplayTime"
      ></gameplay-player-tsx>
    } @else {
      <gameplay-player-ngx
        [setting]="setting"
        [card]="card"
        [didAnswer]="didAnswer"
        [progress]="progress"
        [isAutoplay]="isAutoplay"
        (selected)="onSelect($event)"
        (action)="onAction($event)"
      ></gameplay-player-ngx>
    }
  } @else {
    <nx-superprep-dot-flashing></nx-superprep-dot-flashing>
  }
</div>
